import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../../wires/Identifiers'
import container from '../../../wires/Bootstrapper'

import { TTModalProps } from '../../shared/TTModalProps'
import { IUtenteService } from '../../../services/UtenteService'
import { RuoloClienteInputModel } from '../../../models/UtenteModels'
import { UtenteParams } from './../UtenteParams'
import { ModalContentClienteRole } from './ModalContentClienteRole'

export interface ModalClienteRole {
    clienteId?: string
}


export class ModalClienteRoleComp extends React.Component<RouteComponentProps<UtenteParams> & TTModalProps & ModalClienteRole, any> {

    service: IUtenteService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.UTENTE_SERVICE)
    }

    load = async () => {
        return this.service.RenderAssociaCliente()
    }

    onSave = async (model: RuoloClienteInputModel) => {
        let resp = await this.service.AssociaCliente(model)
        if (resp.IsValid == true) {
            this.props.closeModal()
            this.props.do()
        }
    }

    render() {
        return (
            <ModalContentClienteRole title="Seleziona il Cliente e il Ruolo da associare" 
                                     hasCliente={true} 
                                     hasUfficio={false}
                                     onLoad={this.load} 
                                     onSave={this.onSave}
                visible={this.props.visible} closeModal={this.props.closeModal} clienteId={this.props.clienteId} />
        )
    }
}

export const ModalClienteRole = withRouter(ModalClienteRoleComp)